import { RIGHTS_IS_ON, RIGHTS_MODULES } from '@app/constants';
import type { NAccessRights } from '@app/types/AccessRights';
import type { NNavigation } from '@app/types/Navigation';
import type { UserAccessRightsInterface } from '@app/types/NewAccessRight';
import { checkForAllPathEnds } from '@app/utils';
import { hasModuleRight } from '@app/utils/hasModuleRight';

export const hasViewRight = (
  currentPathName: string,
  navigation: Array<NNavigation.NavigationAllItems>,
  accessRights:
    | NAccessRights.ModelAccessRights
    | UserAccessRightsInterface
    | null
) => {
  // Пользователь - суперадмин
  // права на просмотр не проверяются
  if (accessRights?.IsSuperAdmin) return true;

  const enabledModules = accessRights?.[RIGHTS_MODULES];
  const navigationObject = navigation.find(
    (item: NNavigation.NavigationAllItems) => {
      if (checkForAllPathEnds(currentPathName, item.path)) {
        return true;
      }
    }
  );

  if (!enabledModules) return false;

  // Пользователь - админ
  // проверяются права на модуль
  if (accessRights?.IsAdmin) {
    return hasModuleRight(navigationObject?.servicerightsid, enabledModules);
  }

  const servicerightsid = navigationObject?.servicerightsid;

  // Для просмотра страницы сервиса требуются права
  if (servicerightsid) {
    const moduleAccessRights = accessRights?.[servicerightsid] as
      | { [RIGHTS_IS_ON]: boolean }
      | undefined;

    // Блока прав может не быть: MedicalDocuments до выката бэка (us/10241)
    // или права из localStorage старого формата — безопасный дефолт
    // «разрешено», как вело себя приложение до появления блока.
    if (!moduleAccessRights) return true;

    return !!(
      hasModuleRight(
        servicerightsid as NAccessRights.EntityId,
        enabledModules
      ) && moduleAccessRights[RIGHTS_IS_ON]
    );
  }

  //Для просмотра страницы сервиса НЕ требуются права
  return true;
};
